import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StarIcon, XIcon } from 'lucide-react';
type Comment = {
  id: string;
  name: string;
  location: string;
  text: string;
  date: string;
  rating: number;
  likes: number;
  isLiked: boolean;
  avatarColor: string;
};
const TESTIMONIALS: Comment[] = [{
  id: 'testimonial-1',
  name: 'Marcos F.',
  location: 'CABA',
  text: '¡Che, zarpado este curso! Aprendí un montón de trucos para laburar la madera y la iluminación. ¡Muy recomendable!',
  date: 'hace 2 días',
  rating: 5,
  likes: 47,
  isLiked: false,
  avatarColor: '#2563eb'
}, {
  id: 'testimonial-2',
  name: 'Sol M.',
  location: 'Córdoba',
  text: '¡Increíble! Pensé que iba a ser re difícil, pero los planos están súper claros. Ya tengo mi mesa lista y quedó bárbara.',
  date: 'hace 3 días',
  rating: 5,
  likes: 38,
  isLiked: false,
  avatarColor: '#d946ef'
}, {
  id: 'testimonial-3',
  name: 'Diego R.',
  location: 'Rosario',
  text: '¡Una locura! No tenía ni idea de cómo hacer esto y ahora mis amigos me piden que les haga mesas. ¡Gracias, gente!',
  date: 'hace 5 días',
  rating: 5,
  likes: 52,
  isLiked: false,
  avatarColor: '#f59e0b'
}, {
  id: 'testimonial-4',
  name: 'Lucía B.',
  location: 'Mendoza',
  text: '¡Copado! El curso está re completo y re bien explicado. ¡Me encanta cómo quedó mi espejo infinito!',
  date: 'hace 1 semana',
  rating: 5,
  likes: 29,
  isLiked: false,
  avatarColor: '#10b981'
}, {
  id: 'testimonial-5',
  name: 'Javier G.',
  location: 'Mar del Plata',
  text: '¡Buenísimo! La verdad que me ahorré una banda de guita haciéndolo yo mismo. ¡Muy útil!',
  date: 'hace 1 semana',
  rating: 5,
  likes: 34,
  isLiked: false,
  avatarColor: '#ef4444'
}, {
  id: 'testimonial-6',
  name: 'Camila V.',
  location: 'La Plata',
  text: '¡Tremendo! Le regalé una mesa infinita a mi viejo y no lo podía creer. El paso a paso está genial, no te perdés en nada.',
  date: 'hace 2 semanas',
  rating: 5,
  likes: 41,
  isLiked: false,
  avatarColor: '#8b5cf6'
}];
export function CommentsSection() {
  const [comments, setComments] = useState<Comment[]>(TESTIMONIALS);
  const [newCommentText, setNewCommentText] = useState('');
  const [newCommentRating, setNewCommentRating] = useState(5);
  const [hoverRating, setHoverRating] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handlePublish = () => {
    if (!newCommentText.trim()) return;
    const newComment: Comment = {
      id: `user-comment-${Date.now()}`,
      name: 'Vos',
      location: 'Argentina',
      text: newCommentText,
      date: 'hace un momento',
      rating: newCommentRating,
      likes: 0,
      isLiked: false,
      avatarColor: '#00f0ff'
    };
    setComments(prev => [newComment, ...prev]);
    setNewCommentText('');
    setNewCommentRating(5);
    setIsModalOpen(true);
  };
  const handleLikeToggle = (id: string) => {
    setComments(prev => prev.map(c => {
      if (c.id === id) {
        return {
          ...c,
          isLiked: !c.isLiked,
          likes: c.isLiked ? c.likes - 1 : c.likes + 1
        };
      }
      return c;
    }));
  };
  return <section className="py-8 px-4 bg-white relative z-10 border-t border-gray-200" data-id="element-36">
      <div className="max-w-3xl mx-auto" data-id="element-37">
        {/* Input Area */}
        <div className="bg-gray-50 rounded-2xl p-6 border border-gray-300 shadow-lg" data-id="element-38">
          <div className="flex items-center gap-2 mb-4" data-id="element-39">
            <span className="text-gray-700 text-sm font-medium" data-id="element-40">
              Tu calificación:
            </span>
            <div className="flex gap-1" data-id="element-41">
              {[1, 2, 3, 4, 5].map(star => <button key={star} type="button" aria-label={`Calificar con ${star} estrellas`} onClick={() => setNewCommentRating(star)} onMouseEnter={() => setHoverRating(star)} onMouseLeave={() => setHoverRating(0)} className="focus:outline-none transition-transform hover:scale-110" data-id="element-42">
                  <StarIcon className={`w-6 h-6 ${star <= (hoverRating || newCommentRating) ? 'fill-[#f5c518] text-[#f5c518]' : 'text-gray-600'} transition-colors`} data-id="element-43" />
                </button>)}
            </div>
          </div>
          <textarea value={newCommentText} onChange={e => setNewCommentText(e.target.value)} placeholder="Escribí tu opinión sobre el ebook..." className="w-full bg-white text-gray-900 rounded-xl p-4 min-h-[100px] resize-none focus:outline-none focus:ring-2 focus:ring-blue-500/50 border border-gray-300 transition-all" data-id="element-44" />
          <div className="flex justify-end mt-4" data-id="element-45">
            <button onClick={handlePublish} disabled={!newCommentText.trim()} className="bg-blue-600 text-white font-bold px-6 py-2.5 rounded-xl disabled:opacity-50 disabled:cursor-not-allowed hover:bg-blue-700 transition-colors" data-id="element-46">
              Publicar comentario
            </button>
          </div>
        </div>
      </div>

      {/* Success Modal */}
      <AnimatePresence data-id="element-47">
        {isModalOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" data-id="element-48">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} className="bg-white rounded-2xl p-8 max-w-sm w-full text-center border border-gray-300 shadow-2xl relative" data-id="element-49">
              <button onClick={() => setIsModalOpen(false)} aria-label="Cerrar modal" className="absolute top-4 right-4 text-gray-500 hover:text-gray-900 transition-colors" data-id="element-50">
                <XIcon className="w-5 h-5" data-id="element-51" />
              </button>
              <div className="w-16 h-16 bg-green-500/10 text-green-500 rounded-full flex items-center justify-center mx-auto mb-4 border border-green-500/20" data-id="element-52">
                <StarIcon className="w-8 h-8 fill-current" data-id="element-53" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2 tracking-tight" data-id="element-54">
                ¡Gracias por tu reseña!
              </h3>
              <p className="text-gray-700" data-id="element-55">
                Tu comentario ha sido publicado exitosamente.
              </p>
              <button onClick={() => setIsModalOpen(false)} className="mt-6 w-full bg-blue-600 text-white font-bold py-2.5 rounded-xl hover:bg-blue-700 transition-colors" data-id="element-56">
                Cerrar
              </button>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </section>;
}